import { EDITIONS } from 'constants/merchandising';

const N_THUMBNAILS_PER_SLIDE = 5;

const EDITIONS_PRIORITY = {
  [EDITIONS.CLASSIC]: 0,
  [EDITIONS.LIMITED]: 1,
  [EDITIONS.GRAPHIC]: 2,
  [EDITIONS.THREE_PACKS]: 3,
};

const SIZE_SELECTOR_MODES = {
  GRID: 'Yes (Grid)',
  DROPDOWN: 'Yes (Dropdown)',
  HIDDEN: 'No',
};

const ATTRIBUTE_BLOCK_TYPES = {
  SPECS: 'productSpecs',
  SIZE_CHART: 'sizeChart',
};

const ATTRIBUTE_INLINE_TYPES = {
  CARBON_SCORE: 'carbonScore',
};

const DY_SIDEBAR_RECS_CAMPAIGN = 'PDP Sidebar Recs';
const DY_END_OF_PDP_RECS_CAMPAIGN = 'PDP Recs End of Page';

const MSRP_PRICE_TIER = 'msrp';

const PDP_HERO_GALLERY_VARIATIONS = {
  THUMBNAILS: 'thumbnails',
  BUTTONS: 'buttons',
};

const PDP_STORY_MODULE_SLIDE_TYPES = {
  IMAGE: 'image',
  VIDEO: 'video',
};

const MODULE_TYPES = {
  STORY_MODULE: 'Story Module',
};

const PDP_STORY_MODULE_VISIBILITY = {
  DESKTOP: 'Desktop Web',
  HIDDEN: 'Hidden',
  MOBILE: 'Mobile Web',
};

export {
  N_THUMBNAILS_PER_SLIDE,
  EDITIONS_PRIORITY,
  SIZE_SELECTOR_MODES,
  DY_SIDEBAR_RECS_CAMPAIGN,
  DY_END_OF_PDP_RECS_CAMPAIGN,
  ATTRIBUTE_BLOCK_TYPES,
  ATTRIBUTE_INLINE_TYPES,
  MSRP_PRICE_TIER,
  PDP_HERO_GALLERY_VARIATIONS,
  PDP_STORY_MODULE_SLIDE_TYPES,
  PDP_STORY_MODULE_VISIBILITY,
  MODULE_TYPES,
};
